import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import queryString from 'query-string';
import { Link } from 'react-router-dom';

import history from '../../../../../../commons/history';
import { selectDashboard } from '../../../../DashboardComponents/DashboardCalls';
import WarningLine from './WarningLine';

const WarningDashboard = (props) => {
  const [setPropsData, setSetPropsData] = useState({});

  useEffect(() => {
    if (props && props.location) {
      const { Name, PanelId } = queryString.parse(props.location.search);
      _prepareProperties(Name, PanelId);
    }
  }, [props.location]);

  const _prepareProperties = async (Name, PanelId) => {
    let dashboards = await selectDashboard(Name);
    if (dashboards && dashboards[0] && dashboards[0].json) {
      let filteredPanel = dashboards[0].json.filter(
        (dashboardObject) => dashboardObject.id === Number(PanelId)
      );
      setSetPropsData(
        filteredPanel && filteredPanel[0]
          ? {
              ...filteredPanel[0],
              graphprops: filteredPanel[0]
            }
          : {}
      );
    }
  };

  const translation = (keyword) => {
    let { translationCache } = setPropsData; // Assuming translationCache is part of setPropsData
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  return (
    <div style={{ minHeight: window.innerHeight - 115, backgroundColor: 'rgb(26, 54, 82)' }}>
      <Button style={{ margin: '5px' }} type="primary" onClick={() => history.goBack()}>
        {translation('Go Back')}
      </Button>
      <Link
        style={{ float: 'right', marginRight: '22px' }}
        to={`/rubus/settingsPage/WarningLimits`}
      >
        {translation('Redirect to Warning Limits')}
      </Link>
      <WarningLine {...setPropsData} />
    </div>
  );
};

export default WarningDashboard;